<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>Görev Ekle</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">Görev Ekle</a></li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">Görev Ekle</h3>
            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Görev Başlığı:</label>
                  <input
                    v-model="result.noticetitle"
                    class="form-control"
                    type="text"
                    placeholder="Görev Görüntüleneceği Başlığı Belirtiniz"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Görev İçeriği:</label>
                  <input
                    v-model="result.noticecontent"
                    class="form-control"
                    type="text"
                    placeholder="Görev Hakkındaki Detayları Yazınız"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Görev Tarihi</label>
                  <br />
                  <input
                    v-model="gidertarihi"
                    type="date"
                    id="start"
                    name="trip-start"
                    min="2023-09-27"
                    max="2030-12-31"
                  />
                </div>
                <div>
                  <select class="form-control" @change="getByPersonel($event)">
                    <option value="" selected disabled>Personel Seçiniz</option>
                    <option
                    
                      v-for="result in result2"
                      :value="result.id"
                      :key="result.id"
                      >{{ result.name +" " + result.surname}}</option
                    >
                  </select>
                </div>
            
              </form>
            </div>

            <div class="tile-footer">
              <button
                @click="sendData()"
                class="btn btn-success"
                type="button"
              >
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: {
        noticetitle: null,
        noticecontent: null,
        
      },
      result2 :[],
      id: "",
      user_id: "0",
      gidertarihi: "",
    };
    
  },
  methods: {
    getByPersonel(event) {
      var user_id = event.target.value;
      this.user_id = user_id;
    },
    sendData: function() {
        if (!this.result.noticetitle) {
        this.$swal({
          text: "Lütfen Görev Başlığı Giriniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
      } else if (!this.result.noticecontent) {
        this.$swal({
          text: "Lütfen Görev Açıklamasını Giriniz!!",
          icon: "error",
          closeOnClickOutside: false,
          

        });
        return false;
      }
      var url = store.state.base_url + "AslanSahalar/createNoticeData.php?key=123";

      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
       // sectionsId: localStorage.getItem("sectionsId"),
        gidertarihi: this.gidertarihi,
        noticetitle: this.result.noticetitle,
        user_id: this.user_id,
        noticecontent: this.result.noticecontent,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Görev Başarıyla Eklendi!",
              icon: "success",
              closeOnClickOutside: true,
            });
       //     location.reload();
          }
          this.$router.push("notifications");
          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },

  mounted() {
    this.token = localStorage.getItem("token");
    this.id = localStorage.getItem("id");
    if (!this.token) {
      this.$router.push("/");
    }
    var datas = {
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
    };

    let dataUrl = store.state.base_url + "AslanSahalar/getAllUser.php?key=123";
    return axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result2 = response.data;
    });
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AddNotice.vue